import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import { Globe, ShieldCheck, ArrowSquareOut } from "@phosphor-icons/react";

export default function Domains() {
  const [domains, setDomains] = useState([]);
  useEffect(() => { api.get("/domains").then((r) => setDomains(r.data)).catch(() => {}); }, []);

  return (
    <Layout>
      <div className="mx-auto max-w-5xl px-6 py-10 sm:px-10">
        <h1 className="font-display text-4xl font-bold tracking-tight">Domains</h1>
        <p className="mt-2 text-muted-foreground">Every live app gets a free address with automatic HTTPS.</p>

        <div className="mt-8 space-y-3">
          {domains.length === 0 && (
            <div className="rounded-3xl border border-dashed border-border bg-card p-12 text-center">
              <Globe size={36} weight="duotone" className="mx-auto text-muted-foreground" />
              <p className="mt-4 text-muted-foreground">No live apps yet. Deploy an app to get your first web address.</p>
            </div>
          )}
          {domains.map((d, i) => (
            <motion.div key={d.project_id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              className="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-border bg-card p-6" data-testid={`domain-${d.project_id}`}>
              <div>
                <p className="font-display text-lg font-medium">{d.name}</p>
                <p className="mt-1 flex items-center gap-1.5 font-mono text-sm text-muted-foreground"><Globe size={14} /> {d.subdomain}</p>
                {d.custom_domain && <p className="mt-1 flex items-center gap-1.5 font-mono text-xs text-warning-foreground">{d.custom_domain} · {d.custom_domain_status}</p>}
              </div>
              <div className="flex items-center gap-3">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-success px-3 py-1 text-xs font-semibold text-success-foreground"><ShieldCheck size={14} weight="fill" /> SSL active</span>
                <a href={d.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm font-medium hover:underline">Open <ArrowSquareOut size={14} /></a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
